import React from 'react'

import { useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'

import { PageBlock } from '../'
import {
    Meta,
    Block,
    Hero,
    StickyImage,
    RedArrow,
} from '../Common'


const Home = () => {
    const { page } = useSelector(state => state.content, shallowEqual)
    const { intro_image, hero_image } = page

    return (
        <>
            <Meta page={page} />
            <Hero background={intro_image}>
                {/* TODO clicking the arrow will scroll down  */}
                <RedDownArrow />
            </Hero>
            <StickyImage background={hero_image} />
            {page.blocks && page.blocks.map((pageBlock, i) =>
                <Block key={i.toString()}>
                    <PageBlock pageBlock={pageBlock} url={page.url} />
                </Block>
            )}

        </>
    )
}

const RedDownArrow = styled(RedArrow)`
    transform: rotate(90deg);
    margin-bottom: 50px;
`

export default Home
